export default __webpack_public_path__ + "media/images/features/local_delivery/episode6/LP_01-25cd8e894c60950e5a058454a346e53e.jpeg";